import { createElement, ReactElement } from 'react';
import { Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import useStyles from '../style';

interface IconTypeProps {
  width: number;
  height: number;
}

type IconType = (props: IconTypeProps) => JSX.Element;

type LinkProps = {
  path: string;
  search?: string;
  hash?: string;
  label?: string;
  dataTestId: string;
  icon?: IconType;
  style?: string;
  variant?: string;
  onClick?: () => void;
};

const NavigationLink = ({
  path,
  search,
  hash,
  label,
  dataTestId,
  icon,
  style,
  variant,
  onClick,
}: LinkProps): ReactElement => {
  const location = useLocation();
  const classes = useStyles();

  return (
    <Link
      // @ts-ignore
      to={{ pathname: path, search, hash, state: { from: location.pathname } }}
      data-testid={dataTestId}
      className={style || classes.button}
      onClick={onClick}
    >
      {icon ? (
        createElement(icon)
      ) : (
        <>
          {/* @ts-ignore */}
          <Typography variant={variant || 'body1'} sx={{ fontWeight: 700 }}>
            {label}
          </Typography>
        </>
      )}
    </Link>
  );
};

export default NavigationLink;
